/**
 * <usp-collection-links> — host for the "USP collection links" section. Its only job is to
 * keep the prev/next arrows honest: Swiper's `watchOverflow` measures overflow once at init,
 * but the links are auto-width and only settle after the web font loads, so the first measure
 * (fallback-font width) can leave the slider wrongly un/locked. We re-measure after the font
 * loads and mirror Swiper's lock state onto `data-fits`, which the CSS uses to hide the arrows
 * when every link already fits.
 *
 * Loaded ONLY from sections/section-usp_collection_links.liquid.
 */

class USPCollectionLinks extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.swiperEl = this.querySelector('swiper-init');
    this.onInit = (event) => this.#bind(event.detail.swiper);
    this.swiperEl?.addEventListener('swiper:initialized', this.onInit, { once: true });
  }

  #bind(swiper) {
    this.swiper = swiper;
    const sync = () => this.toggleAttribute('data-fits', swiper.isLocked);

    swiper.on('lock', sync);
    swiper.on('unlock', sync);
    sync();

    // Auto-width links settle after the web font loads → re-measure so the lock (and the
    // arrows it controls) reflects the real overflow, not the fallback-font width.
    document.fonts?.ready.then(() => {
      // The section may have been removed (Customizer re-render) before fonts resolved —
      // swiper-init would have destroyed the instance, so updating it would throw.
      if (!this.isConnected || swiper.destroyed) return;
      swiper.update();
      sync();
    });
  }

  disconnectedCallback() {
    this.swiperEl?.removeEventListener('swiper:initialized', this.onInit);
  }
}

if (!customElements.get('usp-collection-links')) {
  customElements.define('usp-collection-links', USPCollectionLinks);
}
